var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getParamSection)?_c('div',{staticClass:"section__container section__container--one-column"},[(_vm.getParamSection)?_c('div',{staticClass:"section__content"},[_c('DigitalHealth')],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }